import booleanPointInPolygon from '@turf/boolean-point-in-polygon';

/**
 * Marcadores fora das formas desenhadas continuam no mapa, esmaecidos, para o usuário
 * saber onde há imóveis/empreendimentos antes de desenhar a próxima área. Quem está
 * dentro é marcado em `properties.inside`; as camadas leem essa propriedade para
 * decidir a opacidade. Compartilhado entre o mapa de empreendimentos (MapboxMap) e o
 * de revenda e locação (MapaRevendaLocacaoMapbox).
 */
export const OUTSIDE_SHAPE_OPACITY = 0.56;

// Sem nenhuma forma desenhada, `inside` não é gravado — daí a comparação explícita
// com `false`, que trata a ausência da propriedade como "dentro".
export const POINT_OUTSIDE_OPACITY = ['case', ['==', ['get', 'inside'], false], OUTSIDE_SHAPE_OPACITY, 1];

/**
 * Para sources com clusterização do Mapbox (cliente): `inside_count` conta os pontos
 * do cluster que caíram dentro das formas — zero significa cluster inteiramente fora.
 */
export const INSIDE_CLUSTER_PROPERTIES = {
    inside_count: ['+', ['case', ['==', ['get', 'inside'], false], 0, 1]],
};

export const CLUSTER_OUTSIDE_OPACITY = ['case', ['==', ['get', 'inside_count'], 0], OUTSIDE_SHAPE_OPACITY, 1];

/**
 * Grava `properties.inside` em cada feature de ponto e devolve as que caíram dentro
 * de alguma forma. Sem formas, todas contam como dentro.
 *
 * @param {Array<object>} features Features de ponto (mutadas in-place).
 * @param {Array<object>} shapes Polígonos/MultiPolígonos das formas desenhadas.
 * @returns {Array<object>} Subconjunto de `features` dentro das formas.
 */
export function markFeaturesInsideShapes(features, shapes) {
    const temFormas = shapes.length > 0;
    const dentro = [];

    features.forEach((feature) => {
        const isInside =
            !temFormas ||
            shapes.some((shape) => {
                try {
                    return booleanPointInPolygon(feature, shape);
                } catch {
                    return false;
                }
            });

        feature.properties.inside = isInside;
        if (isInside) {
            dentro.push(feature);
        }
    });

    return dentro;
}
